
export const tableStyles = {
  wrapper: {
    border: '1px solid #d4d4d4',
    overflow: 'auto',
    maxHeight: '70vh',
    background: '#fff',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    userSelect: 'none',
    position: 'relative' // Important for resize guide positioning
  },
  table: {
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    fontSize: '12.5px',
    minWidth: '100%',
    color: '#000'
  },
  savingIndicator: {
    position: 'fixed',
    top: '16px',
    right: '4px',
    zIndex: '50',
    backgroundColor: '#3b82f6',
    color: 'white',
    padding: '4px 16px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    animation: 'pulse 2s infinite',
    display: 'flex',
    alignItems: 'center'
  },
  inlineStyles: `
    .excel-th {
      border: 1px solid #d4d4d4;
      height: 30px;
      padding: 2px 6px;
      vertical-align: middle;
      background-color: #f8fafc;
      font-weight: 600;
      color: #1f2937;
      position: sticky;
      top: 0;
      z-index: 10;
      position: relative;
    }
    .excel-td {
      border: 1px solid #d4d4d4;
      height: 26px;
      padding: 2px 6px;
      vertical-align: middle;
      min-width: 50px;
      max-width: 500px;
      cursor: cell;
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .excel-td.selected-cell {
      background-color: #dbeafe !important;
      border: 2px solid #3b82f6 !important;
    }
    .excel-input {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      font: inherit;
      background: transparent;
    }
    .excel-text { 
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .excel-number { 
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      white-space: nowrap;
    }
    
    .bg-blue-50 {
      background-color: #f0f8ff !important;
    }
    
    .excel-td:hover {
      background-color: #f5f5f5 !important;
    }
    
    /* Selection border */
    .excel-wrapper:active {
      cursor: crosshair;
    }
    
    /* Button animations */
    button:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    
    button:not(:disabled):hover {
      transform: translateY(-1px);
      transition: transform 0.2s;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    
    /* Scrollbar styling */
    .excel-wrapper::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    
    .excel-wrapper::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    
    .excel-wrapper::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 5px;
    }
    
    .excel-wrapper::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
    
    /* Floating button animations */
    .fixed button {
      transition: all 0.2s ease;
    }
    
    .fixed button:hover:not(:disabled) {
      transform: scale(1.1);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }
    
    .fixed button:active:not(:disabled) {
      transform: scale(0.95);
    }
    
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.7; }
    }
    
    /* Column Resizer Styles */
    .column-resizer {
      position: absolute;
      top: 0;
      right: -3px;
      width: 6px;
      height: 100%;
      cursor: col-resize;
      z-index: 20;
      background: transparent;
    }
    
    .column-resizer:hover, .column-resizer.resizing {
      background-color: #3b82f6;
    }
    
    .resize-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9999;
      cursor: col-resize;
    }
    
    /* Removed old resize-guide styles since they're handled dynamically */
    .context-menu-scrollable {
      max-height: 400px;
      overflow-y: auto;
    }
    
    .context-menu-scrollable::-webkit-scrollbar {
      width: 6px;
    }
    
    .context-menu-scrollable::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }
    
    .context-menu-scrollable::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
    }
    
    .context-menu-scrollable::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
  `
};
